var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 6.66732C4.55814 6.66732 4.13421 6.49172 3.82165 6.17916C3.50909 5.8666 3.3335 5.44268 3.3335 5.00065C3.3335 4.55862 3.50909 4.1347 3.82165 3.82214C4.13421 3.50958 4.55814 3.33398 5.00016 3.33398C5.44219 3.33398 5.86611 3.50958 6.17867 3.82214C6.49123 4.1347 6.66683 4.55862 6.66683 5.00065C6.66683 5.21952 6.62372 5.43625 6.53996 5.63846C6.4562 5.84067 6.33344 6.0244 6.17867 6.17916C6.02391 6.33393 5.84018 6.45669 5.63797 6.54045C5.43576 6.62421 5.21903 6.66732 5.00016 6.66732ZM5.00016 0.333984C3.76249 0.333984 2.5755 0.82565 1.70033 1.70082C0.825161 2.57599 0.333496 3.76297 0.333496 5.00065C0.333496 8.50065 5.00016 13.6673 5.00016 13.6673C5.00016 13.6673 9.66683 8.50065 9.66683 5.00065C9.66683 3.76297 9.17516 2.57599 8.29999 1.70082C7.42482 0.82565 6.23784 0.333984 5.00016 0.333984Z",
    fill: "#D2820A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.51d994968c62082a039c1c29916b1e6d.svg";
export { ForwardRef as ReactComponent };